import { blockTheme, cn, hsl } from '@teach/ui'

export interface LookCardOption {
  id: string
  label: string
  /** CSS `background` экрана с этой темой и паттерном. */
  background: string
}

interface Props {
  options: LookCardOption[]
  value: string | null
  onChange: (id: string) => void
  disabled?: boolean
  ariaLabel: string
  columns: 3 | 4
}

/**
 * Выбор оформления урока мини-экранами: каждая карточка — маленький телефон в
 * этой теме и с этим паттерном, с намёком на содержимое. Автор видит результат,
 * а не название цвета.
 */
export const LookCardGroup = ({
  options,
  value,
  onChange,
  disabled,
  ariaLabel,
  columns,
}: Props) => (
  <div
    role="radiogroup"
    aria-label={ariaLabel}
    className={cn('grid gap-2.5', columns === 3 ? 'grid-cols-3' : 'grid-cols-4')}
  >
    {options.map((o) => {
      const selected = o.id === value
      return (
        <button
          key={o.id}
          type="button"
          role="radio"
          aria-checked={selected}
          aria-label={o.label}
          disabled={disabled}
          onClick={() => onChange(o.id)}
          className="group flex flex-col items-center gap-1.5 outline-none disabled:cursor-not-allowed disabled:opacity-50"
        >
          <span
            className={cn(
              'relative flex aspect-[9/14] w-full flex-col gap-1 overflow-hidden rounded-xl p-2 ring-offset-2 ring-offset-background transition',
              selected ? 'ring-2 ring-brand' : 'ring-1 ring-border group-hover:ring-foreground/40',
            )}
            style={{ background: o.background }}
          >
            {/* Намёк на экран: заголовок и две строки. */}
            <span
              className="h-1.5 w-3/4 rounded-full"
              style={{ backgroundColor: hsl(blockTheme.foreground, 0.22) }}
            />
            <span
              className="h-1 w-full rounded-full"
              style={{ backgroundColor: hsl(blockTheme.foreground, 0.12) }}
            />
            <span
              className="h-1 w-2/3 rounded-full"
              style={{ backgroundColor: hsl(blockTheme.foreground, 0.12) }}
            />
          </span>
          <span className={cn('text-xs', selected ? 'text-foreground' : 'text-muted-foreground')}>
            {o.label}
          </span>
        </button>
      )
    })}
  </div>
)
